const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/**
 * Compact, low-noise date label: `4 Jun 26`.
 * Accepts a DATE-only string ('YYYY-MM-DD') or any ISO timestamp. Date-only
 * strings are parsed by their components to avoid a timezone shift (a naive
 * 'YYYY-MM-DD' parsed as UTC midnight can render as the previous day locally).
 */
export function fmtShortDate(value: string | null | undefined): string {
  if (!value) return '';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
  let y: number, mo: number, da: number;
  if (m) {
    y = +m[1]; mo = +m[2] - 1; da = +m[3];
  } else {
    const d = new Date(value);
    if (isNaN(d.getTime())) return '';
    y = d.getFullYear(); mo = d.getMonth(); da = d.getDate();
  }
  return `${da} ${MONTHS[mo]} ${String(y).slice(-2)}`;
}
